import {createAction, props} from "@ngrx/store";
import {Brands, GeneralSettingDto, QrTokenDto, ResourceProfileOverviewDto, TenantInfoDto, TokenDto} from '@server-models';
import {EAppType} from "@shared/models/AppType.enum";
import {ISharedLoginStoreState} from "@shared/components/login/store/shared-login.state";

export const setAppType = createAction(
  '[Shared Login] Set App Type',
  props<{ appType: EAppType }>()
);

export const setBrand = createAction(
  '[Shared Login] Set Brand',
  props<{ brand: Brands }>()
);

export const login = createAction(
  '[Shared Login] Login',
  props<{ email: string; passwordBase64: string; }>()
);

export const loginByQuickAccessKey = createAction(
  '[Shared Login] Login By Quick Access Key',
  props<{ key: string; }>()
);

export const getQuickAccessProfile = createAction(
  '[Shared Login] Get Quick Access Profile',
  props<{ token: QrTokenDto; }>()
);

export const getQuickAccessProfileSuccess = createAction(
  '[Shared Login] Get Quick Access Profile Success',
  props<{ profile: ResourceProfileOverviewDto; }>()
);

export const loginSuccess = createAction(
  '[Shared Login] Login Success',
  props<{ token: TokenDto }>()
);

export const loginFail = createAction(
  '[Shared Login] Login Fail',
  props<{ error: Error }>()
);

export const setTenant = createAction(
  '[Shared Login] Set Tenant',
  props<{ tenant: TenantInfoDto }>()
);

export const syncLoginStorage = createAction(
  '[Shared Login] Synchronise Login Storage'
);

export const loadLoginStorage = createAction(
  '[Shared Login] Load Login Storage',
  props<{ resourceId?: number }>()
);

export const loadLoginStorageSuccess = createAction(
  '[Shared Login] Load Login Storage Success',
  props<{ loadedState: ISharedLoginStoreState }>()
);

export const getTenantSettings = createAction(
  '[Shared Login] Get Tenant Settings',
  props<{ tenantId: number }>()
);

export const getTenantSettingsSuccess = createAction(
  '[Shared Login] Get Tenant Settings Success',
  props<{ tenantSettings: GeneralSettingDto }>()
);

export const refreshToken = createAction(
  '[Shared Login] Refresh Token',
  props<{ tenantId?: number }>()
);

export const refreshTokenSuccess = createAction(
  '[Shared Login] Refresh Token Success',
  props<{ newToken: TokenDto, tenantId?: number }>()
);

export const refreshTokenFail = createAction(
  '[Shared Login] Refresh Token Fail',
  props<{ error: any }>()
);

export const checkAppPermission = createAction(
  '[Shared Login] Check App Permission'
);

export const checkAppPermissionSuccess = createAction(
  '[Shared Login] Check App Permission Success'
);

export const checkAppPermissionFail = createAction(
  '[Shared Login] Check App Permission Fail'
);

export const changePassword = createAction(
  '[Shared Login] Change Password',
  props<{ email: string, oldPasswordBase64: string, newPasswordBase64: string }>()
);

export const changePasswordSuccess = createAction(
  '[Shared Login] Change Password Success'
);

export const changePasswordFail = createAction(
  '[Shared Login] Change Password Fail',
  props<{ error: any }>()
);

export const logout = createAction(
  '[Shared Login] Log Out'
);

